export default {
    title: 'Inscription',
    submit_button: 'Enregistrer les informations'
}